// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2_9kD","inner":"Form_inner__3y0fA","range":"Form_range__EuuEo","name":"Form_name__3nvej","actions":"Form_actions__13PHZ"};